export default __webpack_public_path__ + "static/media/recap-payment.eaa1a9d4.svg";